import React, {useEffect, useState} from "react";
import {Toast} from "react-bootstrap";
import {useManageVisitContext} from "../views/quickList/components/context/ManageVisitContext/ManageVisit.context";

export const ToastMessage = ({ title='Error' }) => {
    const manageVisitContext = useManageVisitContext();
    const errorMessage = manageVisitContext?.error_from_services?.errorMessage;


    const [toastObject, setToastObject] = useState({ show: false, message: '', title: '' });

    useEffect(() => {
        if (manageVisitContext && manageVisitContext.error_from_services) {
            if (errorMessage) {
                setToastObject({ show: true, message: errorMessage, title: title })
            }
            else {
                setToastObject({ show: false, message: '', title: '' })
            }

        }

    }, [errorMessage, manageVisitContext, title])

    const onToastCloseHandler=()=>{
        manageVisitContext.persistErrorMessage('')
    }

    return (
        <>
            <Toast onClose={onToastCloseHandler} show={toastObject.show} variant="primary" position="bottom-end" className="position-fixed bottom-0 end-0 zindex-1040 text-bg-primary m-3">
                <Toast.Header className="border-bottom-0 bg-primary p-4 pb-0" closeButton={true}>
                    <strong className="me-auto fs-5 text-white">{toastObject.title}</strong>
                </Toast.Header>
                <Toast.Body className="bg-primary rounded-3 p-4">
                    {toastObject.message}
                </Toast.Body>
            </Toast>
        </>
    );
};

export default ToastMessage;
